import { TopicPageWithContext } from './TopicPage';

export default TopicPageWithContext;
